import RepositoryFactory from "@/builder/apis";
const notification = RepositoryFactory.notification;

export default {
  getByPage({ commit }, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await notification.getByPage(payload);

        commit("SET_STATE", { key: "pageNotifications", value: data.data });

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  read({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await notification.read(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getByProject({}, payload = {}) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await notification.getByProject(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
